var provinces = [
    {
        "province" : "Alberta",
        "id": "alberta"
    },
    {
        "province" : "British Columbia",
        "id": "british-columbia"
    },
    {
        "province" : "Manitoba",
        "id": "manitoba"
    },
    {
        "province" : "New Brunswick",
        "id": "new-brunswick"
    },
    {
        "province" : "Newfoundland and Labrador",
        "id": "newfoundland"
    },
    {
        "province" : "Northwest Territories",
        "id": "northwest-territories"
    },
    {
        "province" : "Nova Scotia",
        "id": "nova-scotia"
    },
    {
        "province" : "Nunavut",
        "id": "nunavut"
    },
    {
        "province" : "Ontario",
        "id": "ontario"
    },
    {
        "province" : "Prince Edward Island",
        "id": "prince-edward-island"
    },
    {
        "province" : "Quebec",
        "id": "quebec"
    },
    {
        "province" : "Saskatchewan",
        "id": "saskatchewan"
    },
    {
        "province" : "Yukon Territory",
        "id": "yukon"
    },
]


var locations = [
    { 
        "title": "199 Avenue Rd",
        "street": "199 Avenue Rd",
        "city": "Toronto",
        "province": "ontario",
        "address": "199 Avenue Rd Toronto, ON M5R 2J3",
        "lat": 43.6757487,
        "lng": -79.3968848,
        "phone": "416-620-6861",
    },
    { 
        "title": "230 Brown's Line",
        "street": "230 Brown's Line",
        "city": "Etobicoke",
        "province": "ontario",
        "address": "230 Brown's Line, Etobicoke, ON M8W 3T4",
        "lat": 43.5978805,
        "lng": -79.5440654,
        "phone": "416-620-6861",
    }
];


var style_json = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        //"visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        //"visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        //"visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
]